<template>
    <div class="page">
        <div class="page-top"></div>
        <div class="project_text" ref="project_text">
             <p class="index-common_title tc">
                使用项目
            </p>
            <p class="index-common_subtitle tc">
               满足你业务的多样性和无限的可能性
            </p>
        </div>
        <div class="project_list" ref="project_list">
            <ul>
                <li class="item">
                    <p>账号注册</p>
                </li>
                <li class="item">
                    <p>游戏测试</p>
                </li>
                <li class="item">
                    <p>营销优化</p>
                </li>
                <li class="item">
                    <p>推广营销</p>
                </li>
                <li class="item">
                    <p>网站采集</p>
                </li>
                <li class="item">
                    <p>论坛发帖</p>
                </li>
                <li class="item">
                    <p>投票助力</p>
                </li>
                <li class="item">
                    <p>问答推广</p>
                </li>
                <li class="item">
                    <p>爬虫抓取</p>
                </li>
                <li class="item">
                    <p>SEO优化</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'project',
    props: {
        project_aimation: Boolean
    },
    watch: {
        project_aimation () {
            this.$refs.project_text.classList.add("project_textAn")
            this.$refs.project_list.classList.add("project_listAn")
        }
    },
    mounted () {
      // let liItems = document.querySelector('.project_list').getElementsByTagName('li')
      // for(var key in liItems) {
      //   if(key == 'length'){
      //       return
      //   }
      //   liItems[key].addEventListener('click',() => {
      //     this.$router.push('/Download')
      //   })
      // }
    }
}
</script>

<style lang="stylus" scoped>
    .page
        background: #f3f3f3 center no-repeat
    .page-top
        border-color #f5f7f9 transparent transparent
    .project_text
        transform  translateY(-100px)
        transition all 1s ease
        opacity 0
    .project_list
        transform  translateY(100px)
        transition all 1s ease
        opacity 0
        width 1380px
        margin 0 auto
        padding-bottom 100px
    .project_textAn, .project_listAn
        transform  translateY(0px)
        opacity 1
    .project_list ul
        width 1380px
        margin 0 auto
        &::after
            content ''
            display block
            height 0rem
            clear both
    .project_list ul li
        width 20%
        float left
        height 2rem
        margin-top 50px
        position relative
        background-repeat no-repeat
        background-position center
        animation rock 2s ease-in-out
        animation-delay 10s
        animation-iteration-count 10
    .project_list ul li p
        position absolute
        bottom -10px
        left 50%
        margin-left -28px
    .project_list ul li:nth-child(1){
        background-image url("~@/assets/img/index_img/5_icon_registered_normal.png")
    }
    .project_list ul li:nth-child(2){
        background-image url("~@/assets/img/index_img/5_icon_game_normal.png")
    }
    .project_list ul li:nth-child(3){
        background-image url("~@/assets/img/index_img/5_icon_optimize_normal.png")
    }
    .project_list ul li:nth-child(4){
        background-image url("~@/assets/img/index_img/5_icon_promote_normal.png")
    }
    .project_list ul li:nth-child(5){
        background-image url("~@/assets/img/index_img/5_icon_web_normal.png")
    }
    .project_list ul li:nth-child(6){
        background-image url("~@/assets/img/index_img/5_icon_bbs_normal.png")
    }
    .project_list ul li:nth-child(7){
        background-image url("~@/assets/img/index_img/5_cion_vote_normal.png")
    }
    .project_list ul li:nth-child(8){
        background-image url("~@/assets/img/index_img/5_icon_qa_normal.png")
    }
    .project_list ul li:nth-child(9){
        background-image url("~@/assets/img/index_img/5_icon_webcrawler_normal.png")
    }
    .project_list ul li:nth-child(10){
        background-image url("~@/assets/img/index_img/5_icon_seo_normal.png")
    }
    @media screen and (max-width: 1200px)
        .project_list
            width auto
            margin auto
    @media (min-width: 768px) and (max-width: 1642px)
        .project_list ul
            width 100%
    @media screen and (max-width: 768px)
        .project_list ul
            width 100%
        .project_list ul li
            background-size 40% 50%
        .project_list ul li p
            font-size 12px
     @media screen and (max-width: 456px)
        .project_list ul li
            background-size 40% 40%
    @keyframes rock{
        0%{
            transform: rotate(0deg);
        }
        10%{
            transform: rotate(3deg);
        }
        20%{
            transform: rotate(-3deg);
        }
        30%{
            transform: rotate(2deg);
        }
        40%{
            transform: rotate(-2deg);
        }
        50%{
            transform: rotate(1deg);
        }
        60%{
            transform: rotate(-1deg);
        }
        70%{
            transform: rotate(0deg);
        }
        100%{
            transform: rotate(0deg);
        }
    }
</style>




// WEBPACK FOOTER //
// src/pages/Home/components/project.vue